import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'

import { RentalSectionHeaderWrapper } from '../OrderPreSummaryBox/styles'
import { JSX } from 'react'

type Props = {
  isProlonging: boolean
  step: number
}

const RentalSectionHeader = ({ isProlonging, step }: Props): JSX.Element => {
  const { t } = useTranslation(['common'])

  return (
    <RentalSectionHeaderWrapper>
      <Box paddingRight="40px">
        {step === 1 && (
          <Text fontSize="md" fontWeight="bold">
            {t(isProlonging ? 'changeRentalPeriod' : 'selectRentalPeriod')}
          </Text>
        )}
        {step === 2 && (
          <Text fontSize="md" fontWeight="bold">
            {t('selectAdditionalOptions')}
          </Text>
        )}
        {!isProlonging && (
          <Text fontSize="xs" fontWeight="bold" color="green.a200">
            {t('stepXofY', { current: step, maximum: 2 })}
          </Text>
        )}
      </Box>
    </RentalSectionHeaderWrapper>
  )
}

export default RentalSectionHeader
